<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <span>Politicas de Segurança</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">

        <div class="row">
        <div class="col-xs-12">
            <h3 class="box-title first">Politicas de Segurança</h3>
        </div>
        </div>
        <div class="row">
            <div class="col-xs-12 static-text">
                <p>A Aldo sabe o quanto sua segurança é importante, por isso é que se preocupa muito com isso, e garante a sua tranqüilidade ao navegar em nosso site.</p>
                <p>O site da Aldo é extremamente seguro tanto para os clientes cadastrados no Aldo Crazy Web, quanto para os que não são cadastrados. Todas as transações são realizadas com total segurança e todos os seus dados são arquivados em um ambiente de plena confiança.</p>
                <p>As informações são utilizadas na formação de uma base de dados que permite a personalização dos serviços que prestamos aos nossos clientes.</p>
                <p>Para armazenar nossa base de dados, utilizamos servidores com tecnologia de ponta Intel XeonTM e com softwares desenvolvidos sob a plataforma Microsoft®, garantindo total sigilo contra cópias indevidas ou acesso de terceiros.</p>
                <p>Utilizamos também a tecnologia ASP.NET - que são um ambiente para programação por scripts no servidor, na qual criamos páginas dinâmicas, interativas e de alta performance. Com as páginas ASP.NET, os scripts rodam no nosso servidor e não no cliente. É o próprio servidor que transforma os scripts em HTML padrão, fazendo com que qualquer browser do mercado seja capaz de acessar nosso site.</p>
                <p>Para ter acesso a determinadas áreas e/ou serviços do Site, será necessário o uso de sua senha, juntamente com o CNPJ ou Usuário de sua empresa. Esta senha, evidentemente, é sigilosa e não deve ser compartilhada com qualquer pessoa ou instituição. A Aldo não autorizará nenhum terceiro a solicitar sua senha, CNPJ ou usuário.</p>

            </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "PoliceOfSecurity"
};
</script>
